import initialStates from '../../initialStates';
import {
    CLEAR_BANK_ENTRIES,
    FETCH_BANK_ENTRIES_FAILURE,
    FETCH_BANK_ENTRIES_REQUEST,
    FETCH_BANK_ENTRIES_SUCCESS,
} from './bankEntries-actions';

const defaultState = initialStates.bankEntries || {
    list: [],
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0,
    loading: false,
};

const bankEntriesReducer = (state = defaultState, action) => {
    switch (action.type) {
    case FETCH_BANK_ENTRIES_REQUEST:
        return { ...state, loading: true };

    case FETCH_BANK_ENTRIES_SUCCESS:
        return {
            ...state,
            loading: false,
            list: action.data.content || [],
            page: action.data.page || 0,
            size: action.data.size || 10,
            totalElements: action.data.totalElements || 0,
            totalPages: action.data.totalPages || 0,
        };

    case FETCH_BANK_ENTRIES_FAILURE:
    case CLEAR_BANK_ENTRIES:
        return { ...defaultState };

    default:
        return state;
    }
};

export default bankEntriesReducer;
